import Button from '@/Components/Button/Button';
import type NewWordsStore from '@/Stores/NewWords/NewWordsStore';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import type NewWordStatus from '../../../Models/NewWords/NewWordStatus';
import NewWordDialog from '../Dialog/NewWordDialog';
import NewWordsFilterPanel from '../NewWordsFilterPanel';
import NewWordTable from '../NewWordTable';
import Styles from './NewWordsTab.module.scss';

const NewWordsTab = observer(({ statusOfWords, store }: { statusOfWords: NewWordStatus; store: NewWordsStore }): React.ReactElement => {
    const { t } = useTranslation();

    const detailStore = store.detailStore;

    return (
        <div className={Styles.container}>
            <div>
                <NewWordsFilterPanel store={store} />
            </div>
            <div className={Styles.tableContainer}>
                <NewWordTable store={store} />
            </div>
            <div>
                <Button onClick={() => {
                    store.setSelectedWordAndOpenDialog(undefined); 
                }}>{t('AddNew')}</Button>
            </div>

            {detailStore.state.isOpen && <NewWordDialog store={store} />}
        </div>
    );
});

export default NewWordsTab;
